import React, { Component } from 'react'
import { connect } from 'react-redux'

import classNames from './Libraries.css'
import { fetchLibraries, saveLibrary, deleteLibrary } from '../redux/libraries'
import { fetchHierarchy } from '../redux/hierarchy'
import LoadingSpinner from '../components/LoadingSpinner'
import ErrorMessage from '../components/ErrorMessage'
import Icon from '../components/Icon'

class Libraries extends Component {
  state = {
    editing: null,
    saving: false
  }
  componentDidMount () {
    const { data, fetchLibraries, hierarchy, fetchHierarchy } = this.props
    if (!data) fetchLibraries()
    if (!hierarchy) fetchHierarchy()
  }
  onCreate = e => {
    const { saveLibrary } = this.props
    e.preventDefault()
    saveLibrary({ library_token: this.state.createName })
    this.setState({ createName: '' })
  }
  renderLibrary = library => {
    const { saveLibrary, deleteLibrary } = this.props
    const { editing, editName } = this.state
    const isEditing = editing && editing.id === library.id
    const onEdit = () => {
      this.setState({
        editing: library,
        editName: library.library_token
      })
    }
    const onDelete = () => {
      if (window.confirm(`Are you sure you want to delete ${library.library_token}? This action cannot be undone.`)) {
        deleteLibrary(library.id)
      }
    }
    const onSave = () => {
      saveLibrary({ library_token: editName }, library.id).then(() => {
        this.setState({
          editing: null
        })
      })
    }
    return (
      <tr key={library.id}>
        <td>
          {library.id}
        </td>
        <td>
          {isEditing
            ? <input
              type='text'
              value={editName}
              onChange={e => this.setState({ editName: e.target.value })}
              className={classNames.input}
              autoFocus
            />
            : library.library_token
          }
        </td>
        {isEditing
          ? <td>
            <button
              onClick={onSave}
              className={classNames.iconButton}
              disabled={!editName}>
              <Icon icon='tick' />
            </button>
          </td>
          : <td className={classNames.nowrap}>
            <button
              onClick={onEdit}
              className={classNames.iconButton}>
              <Icon icon='edit' size={16} />
            </button>
            <button
              onClick={onDelete}
              className={classNames.iconButton}>
              <Icon icon='close' />
            </button>
          </td>
        }
      </tr>
    )
  }
  render () {
    const { data, fetching, error, fetchLibraries } = this.props

    if (error) {
      return (
        <ErrorMessage
          message='There was an error fetching libraries'
          onRetry={fetchLibraries}
        />
      )
    }

    if (!data || fetching) {
      return <LoadingSpinner />
    }

    const { submitting, extra } = this.props
    const { createName } = this.state

    return (
      <div className={classNames.page}>
        <table className={classNames.table}>
          <tbody>
            <tr>
              <th>ID</th>
              <th>Name</th>
              <th>Tools</th>
            </tr>
            {data.map(this.renderLibrary)}
          </tbody>
        </table>
        <form onSubmit={this.onCreate}>
          <label>
            Add Library
            <input
              type='text'
              value={createName}
              className={classNames.input}
              onChange={e => this.setState({ createName: e.target.value })}
              autoFocus
            />
          </label>
          <input
            type='submit'
            value='Add Library'
            className={classNames.createButton}
            disabled={!createName}
          />
        </form>
        {submitting &&
          <LoadingSpinner />
        }
        {this.props.submitError &&
          <p className={classNames.error}>
            An unknown error occured
          </p>
        }
        <ul>
          <li className={classNames.heading}>
            Available Libraries
          </li>
          {!extra &&
            <LoadingSpinner />
          }
          {extra && extra.map(key => {
            const className = data.map(lib => lib.library_token).indexOf(key) !== -1 ? classNames.existing : ''
            return (
              <li key={key} className={className}>
                {key}
              </li>
            )
          })}
        </ul>
      </div>
    )
  }
}

const mapStateToProps = ({ libraries, hierarchy }) => ({
  ...libraries,
  extra: hierarchy.data && Object.keys(hierarchy.data).filter(key => key !== '<leaves>')
})

const mapDispatchToProps = {
  fetchLibraries,
  saveLibrary,
  deleteLibrary,
  fetchHierarchy
}

export default connect(mapStateToProps, mapDispatchToProps)(Libraries)



// WEBPACK FOOTER //
// ./src/pages/Libraries.js